import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons";

const IconForMap = ({lat,lng}) => {
  return (
    <div
      style={{
        width: '30px', height: '40px', position: 'relative', top: -40, left: -15,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        textAlign: 'center'
      }}
      lat={lat}
      lng={lng}>
      <FontAwesomeIcon icon={faMapMarkerAlt}
                       style={{color: '#de4229', fontSize: 30}}/>
    </div>
  );
};

export default IconForMap;
